import { ReactNode } from "react";

import TextEllipsis from "ds/components/TextEllipsis";
import Typography from "ds/components/Typography";

type TableCellTextProps = {
  children: ReactNode;
};

const TableCellText = ({ children }: TableCellTextProps) => {
  return (
    <TextEllipsis tooltip={children}>
      {(props) => (
        <Typography {...props} variant="p-body3" tag="span">
          {children}
        </Typography>
      )}
    </TextEllipsis>
  );
};

TableCellText.displayName = "DS.Table.CellText";

export default TableCellText;
